'use strict';


export default {
    url: '/',
    alias: 'file',
    headers: {},
    queue: [],
    progress: 0,
    autoUpload: false,
    removeAfterUpload: false,
    method: 'POST',
    filters: [],
    formData: [],
    queueLimit: Number.MAX_VALUE,
    withCredentials: false,
    disableMultipart: false
};


/** WEBPACK FOOTER **
 ** ./src/values/options.js
 **/